import { UtmCampaign, UtmContent, UtmMedium, UtmSource } from 'tracking/utm-tracking/types';
import queryString from 'query-string';
import { addQueryParamsToPath } from 'utils/url-query-params/url-query-params';

type utmTrackingParamsProps = {
    utmSource: UtmSource;
    utmMedium: UtmMedium;
    utmCampaign: UtmCampaign;
    utmContent?: UtmContent;
};

export const getUtmTrackingParams = ({
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
}: utmTrackingParamsProps): string => {
    return queryString.stringify({
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
    });
};

export const addUtmTrackingParamsToUrl = ({
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
    url = window.location.href,
}: utmTrackingParamsProps & { url?: string }): string => {
    const utmTrackingParams = getUtmTrackingParams({
        utmSource,
        utmMedium,
        utmCampaign,
        utmContent,
    });

    return addQueryParamsToPath(url, utmTrackingParams);
};

export const PLACER_URL = 'https://www.placer.ai/';
